import styles from './PornHubLayout.module.scss';

const pressStripes = [
    ["NewYorkTimes", "Forbes", "MarieClaire"],
    ["Forbes", "MarieClaire", "Newsweek"],
]

const PornHubLayout = ({children}) => {
    return (
        <div className={styles.pornHubLayout}>

            {pressStripes.map((stripe, i)=>
            <div className={`${styles.pressStripe} ${styles[`pressStripe${i === 0 ? "-left" : "-right"}`]}`} key={i}>
                {stripe.map((press)=>
                <div className={styles.pressImgWrapper} key={press}>
                    <img src={`/next/media/${press}.png`} alt={press} />
                </div>
                )}
            </div>
            )}
            
            {children}
        </div>
    )
}

export default PornHubLayout